import CrisisMontoringLists from "./crisis-monitoring-lists";

export default CrisisMontoringLists;